"use client";
import { useState, useEffect } from "react";
import { FaRegClock } from "react-icons/fa";

interface TimeLeft {
  dias: number;
  horas: number;
  minutos: number;
  segundos: number;
}

// Componente CountdownTimer
const CountdownTimer: React.FC = () => {
  const calculateTargetDate = (): string => {
    const today = new Date();
    const target = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7 - today.getDay(), 23, 59, 59);
    return target.toISOString();
  };

  const [targetDate, setTargetDate] = useState<string | null>(null);
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    dias: 0,
    horas: 0,
    minutos: 0,
    segundos: 0,
  });

  useEffect(() => {
    setTargetDate(calculateTargetDate());

    const calculateTimeLeft = (): TimeLeft => {
      const now = new Date();
      const difference = +new Date(targetDate || "") - +now;
      if (difference > 0) {
        return {
          dias: Math.floor(difference / (1000 * 60 * 60 * 24)),
          horas: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutos: Math.floor((difference / 1000 / 60) % 60),
          segundos: Math.floor((difference / 1000) % 60),
        };
      } else {
        return { dias: 0, horas: 0, minutos: 0, segundos: 0 };
      }
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const formatTime = (time: number): string => String(time).padStart(2, "0");

  const timerComponents = (
    <div className='flex space-x-1 items-center justify-center gap-3'>
      <div>{formatTime(timeLeft.dias)}d</div>
      <div>{formatTime(timeLeft.horas)}h</div>
      <div>{formatTime(timeLeft.minutos)}m</div>
      <div>{formatTime(timeLeft.segundos)}s</div>
    </div>
  );

  return (
    <div className='absolute top-0 w-full flex justify-center items-center bg-count-time text-white text-center z-10 h-12'>
      <h2 className='mr-2 text-lg font-semibold flex items-center gap-2'>
        <FaRegClock /> Teste Grátis:
      </h2>
      {timerComponents}
    </div>
  );
};

export default CountdownTimer;
